import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useAuth, login } from "@/context/AuthContext";
import { AttachNoteDialog } from "@/components/journey/AttachNoteDialog";
import { SuggestEntityDialog } from "@/components/journey/SuggestEntityDialog";
import {
  HighlightedQuestion,
  ComparisonView,
  ResultCard,
  AICard,
  EmptyCard,
} from "./answerParts";

export function AnswerCard({ question, data }) {
  const navigate = useNavigate();
  const { user } = useAuth();
  const openEntity = (id) => navigate(`/explore?focus=${encodeURIComponent(id)}`);

  const [noteEntity, setNoteEntity] = useState(null);
  const [noteOpen, setNoteOpen] = useState(false);
  const [suggestOpen, setSuggestOpen] = useState(false);

  const onAddNote = (r) => {
    if (!user) { login(); return; }
    setNoteEntity({ id: r.id, label: r.label });
    setNoteOpen(true);
  };
  const onSuggest = () => {
    if (!user) { login(); return; }
    setSuggestOpen(true);
  };

  const dialogs = (
    <>
      <AttachNoteDialog open={noteOpen} onOpenChange={setNoteOpen} presetNode={noteEntity} />
      <SuggestEntityDialog open={suggestOpen} onOpenChange={setSuggestOpen} presetName={question} />
    </>
  );

  if (data.source === "curated") {
    const isComparison = data.recognized_from_query && data.results.length === 2;
    return (
      <>
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
          data-testid="answer-curated"
        >
          <p className="text-sm text-[#14140f]/50 mb-4">
            {data.recognized_from_query ? (
              <>
                Understood:{" "}
                <span className="text-[#14140f]/80">
                  <HighlightedQuestion
                    text={data.query || question}
                    terms={data.recognized_terms}
                    onTermClick={openEntity}
                  />
                </span>
              </>
            ) : (
              <>
                {data.results.length} entr{data.results.length !== 1 ? "ies" : "y"} in the graph for
                <span className="text-[#14140f] font-medium"> “{question}”</span>
              </>
            )}
          </p>
          <div className="space-y-3">
            {isComparison ? (
              <ComparisonView results={data.results} onOpen={openEntity} onAddNote={onAddNote} />
            ) : (
              data.results.map((r) => <ResultCard key={r.id} r={r} onOpen={openEntity} onAddNote={onAddNote} />)
            )}
          </div>
        </motion.div>
        {dialogs}
      </>
    );
  }

  if (data.source === "ai") {
    return <>{<AICard answer={data.ai_answer} onSuggest={onSuggest} />}{dialogs}</>;
  }

  return <>{<EmptyCard message={data.message} onSuggest={onSuggest} />}{dialogs}</>;
}
